import * as types from './constants';

const initialState = {
  data: {},
  createLoading: false,
  errors_api: {}
};

const actions = {
  // Create Shopify Token
  [types.CREATE_SHOPIFY_TOKEN_REQUEST]: state => {
    const data = {
      ...state,
      createLoading: true
    };

    return { ...data };
  },

  [types.CREATE_SHOPIFY_TOKEN_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      createLoading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.CREATE_SHOPIFY_TOKEN_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      createLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.CREATE_SHOPIFY_TOKEN_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

